import { render, staticRenderFns } from "./ProjectLineItem.vue?vue&type=template&id=e1247fb6"
import script from "./ProjectLineItem.vue?vue&type=script&lang=js"
export * from "./ProjectLineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports